import { fetchWithAuth } from '@shared/utils/auth';
import { backendUrl } from '@shared/constants/urls/appUrls';
//------------------------------------------------------------------------------
//                  Отправить запрос на получение отфильтрованных данных
//------------------------------------------------------------------------------
export const getFilteredPosts = async (slug, { signal } = {}) => {
  const url = `${backendUrl}/api/alpha/channels/${slug}/?page=1`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    signal,
  };
  try{
    const response = await fetchWithAuth(url, options, { signal });
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении отфильтрованных постов: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch{
    console.error('Ошибка получения отфильтрованных постов:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx